import posthog from 'posthog-js';

/**
 * A simple wrapper around PostHog's capture method.
 * @param eventName The name of the event to capture.
 * @param properties An object of key-value pairs to send with the event.
 */
const track = (eventName: string, properties?: Record<string, any>) => {
  posthog.capture(eventName, properties);
};

/**
 * Identifies a user in PostHog.
 * @param userId The user's unique ID.
 * @param properties An object of user properties (e.g., email, name).
 */
const identify = (userId: string, properties: Record<string, any>) => {
  posthog.identify(userId, properties);
};

/**
 * Resets the PostHog user identification.
 */
const reset = () => {
  posthog.reset();
};

/**
 * Tracks the creation of a new agent.
 */
const trackAgentCreated = (properties: {
  agent_id: string;
  model: string;
  tool_count: number;
  knowledge_base_file_count: number;
}) => {
  track('agent_created', properties);
};

/**
 * Tracks the update of an existing agent.
 */
const trackAgentUpdated = (properties: {
  agent_id: string;
  updated_fields: string[];
}) => {
  track('agent_updated', properties);
};

export const analytics = {
  identify,
  reset,
  trackAgentCreated,
  trackAgentUpdated,
};
